import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-fire-fill text-2xl w-7 h-7 flex items-center justify-center"></i>
            <span className="font-heading text-xl font-bold tracking-wide">小辣椒影院</span>
          </Link>

          {/* Desktop Navigation - centered */}
          <div className="hidden md:flex items-center gap-1 absolute left-1/2 -translate-x-1/2">
            <Link
              to="/"
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                location.pathname === '/'
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  location.pathname.includes(`/category/${cat.slug}`)
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          {/* Search icon (desktop) */}
          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索电影、电视剧..."
                className="w-48 pl-9 pr-4 py-2 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm w-4 h-4 flex items-center justify-center"></i>
            </div>
          </div>

          {/* Mobile hamburger */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 hover:text-primary-500 transition-colors"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden transition-all duration-300 overflow-hidden ${
          mobileMenuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="bg-background-50 border-t border-background-200 px-4 py-4 flex flex-col gap-2">
          <Link
            to="/"
            className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors whitespace-nowrap"
          >
            首页
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors whitespace-nowrap"
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors whitespace-nowrap"
          >
            关于我们
          </Link>
          <div className="relative mt-2">
            <input
              type="text"
              placeholder="搜索电影、电视剧..."
              className="w-full pl-10 pr-4 py-2.5 rounded-lg bg-background-100 border border-background-200 text-sm text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-primary-300 transition-all"
            />
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm w-4 h-4 flex items-center justify-center"></i>
          </div>
        </div>
      </div>
    </nav>
  );
}